import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function CigaretteLitIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M7 15.0001V19.0001M21 15.0001V19.0001M16 6.00003C16 9.00003 18 9.00003 18 12M13 15.0001H18V19.0001H3V15.0001H12.8182M19 5C19 8 21 8 21 11"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
